import { render, staticRenderFns } from "./RefillsStockPanel.vue?vue&type=template&id=2ec61fbb&scoped=true"
import script from "./RefillsStockPanel.vue?vue&type=script&lang=js"
export * from "./RefillsStockPanel.vue?vue&type=script&lang=js"
import style0 from "./RefillsStockPanel.vue?vue&type=style&index=0&id=2ec61fbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec61fbb",
  null
  
)

export default component.exports